@if (loading) {
<div class="panel-card text-center text-muted py-5">
  <i class="fa-solid fa-spinner fa-spin me-2"></i> Toplantı yükleniyor...
</div>
} @else if (!meeting) {
<div class="panel-card text-center text-muted py-5">
  Toplantı bulunamadı. <a routerLink="/meetings">Toplantı listesine dön</a>.
</div>
} @else {

<!-- Davet linkiyle gelen katılımcı: isim girişi -->
@if (showJoin) {
<div class="join-overlay">
  <div class="join-card panel-card">
    <div class="text-center mb-3">
      <div class="op-avatar mx-auto mb-2">M</div>
      <h5 class="mb-1">Toplantıya Katıl</h5>
      <div class="text-muted small join-topic">{{ plain(meeting.topic) }}</div>
    </div>
    <label class="form-label fw-semibold">Adınız</label>
    <input class="form-control mb-3" [(ngModel)]="joinName" placeholder="Örn: Doğukan" maxlength="100"
      (keydown.enter)="join()">
    <button class="btn btn-primary w-100" [disabled]="joining || !joinName.trim()" (click)="join()">
      @if (joining) { <i class="fa-solid fa-spinner fa-spin me-2"></i> } @else { <i
        class="fa-solid fa-right-to-bracket me-2"></i> }
      Katıl
    </button>
  </div>
</div>
}

<!-- ===== Oda: sabit yükseklik; yalnızca akış ve sağ pano kendi içinde kayar ===== -->
<div class="room" [class.report-mode]="showReport && reportHtml">

  <!-- Header: konu + durum + katılımcılar + roller + bütçe (tümü burada) -->
  <div class="panel-card room-header">
    <div class="rh-top">
      <div class="rh-head">
        <a routerLink="/meetings" class="rh-back" title="Toplantılara dön"><i class="fa-solid fa-arrow-left"></i></a>
        <div class="rh-head-main">
          <div class="room-topic" [innerHTML]="topicHtml"></div>
          <!-- Başlık altında tek sıra: tür + durum + derinlik + rapor butonları -->
          <div class="rh-badges">
            <span class="badge text-bg-light">{{ meeting.meetingType }}</span>
            <span class="badge" [class.text-bg-success]="meeting.status === 'Active'"
              [class.text-bg-warning]="meeting.status === 'WrapUp' || meeting.status === 'Closing'"
              [class.text-bg-dark]="meeting.status === 'Completed'"
              [class.text-bg-secondary]="meeting.status === 'Setup'">{{ statusLabel(meeting.status) }}</span>
            <span class="badge text-bg-light" title="Toplantı derinliği"><i class="fa-solid fa-gauge-high me-1"></i>{{
              modelLabel(meeting.model) }}</span>
            @if (meeting.status !== 'Completed' && meeting.status !== 'Setup') {
            <button class="btn btn-sm btn-outline-primary rh-badge-btn" [disabled]="finalizing" (click)="finalize()"><i
                class="fa-solid fa-file-lines me-1"></i>Final Raporu</button>
            }
            @if (meeting.finalReport) {
            <button class="btn btn-sm btn-outline-primary rh-badge-btn" (click)="showReport = !showReport"><i
                class="fa-solid fa-file-lines me-1"></i>{{ showReport ? 'Konuşmalar' : 'Rapor' }}</button>
            }
          </div>
        </div>
      </div>

      <!-- Sağ üst: yalnızca kredi barı -->
      <div class="rh-side">
        <div class="rh-budget">
          @if (!editingBudget) {
          <div class="rb-line">
            <span class="rb-label">Bütçe</span>
            <strong>{{ meeting.creditsUsed | number:'1.0-1' }} / {{ meeting.creditBudget | number }} kredi</strong>
            @if (meeting.status !== 'Completed') {
            <button class="btn btn-sm btn-link p-0 ms-1" title="Bütçeyi güncelle" (click)="editingBudget = true"><i
                class="fa-solid fa-pen"></i></button>
            }
          </div>
          <div class="progress">
            <div class="progress-bar" [class]="'progress-bar ' + budgetClass" [style.width.%]="budgetPct"></div>
          </div>
          <div class="rb-pct">%{{ budgetPct }}
            @if (budgetPct >= 90) { <span class="text-danger fw-semibold">— kapanış</span> }
            @else if (budgetPct >= 80) { <span class="text-warning fw-semibold">— toparlama</span> }
          </div>
          } @else {
          <div class="input-group input-group-sm">
            <input type="number" class="form-control" [(ngModel)]="newBudget" min="1" step="5">
            <span class="input-group-text">kredi</span>
            <button class="btn btn-primary" (click)="saveBudget()"><i class="fa-solid fa-check"></i></button>
            <button class="btn btn-outline-secondary" (click)="editingBudget = false"><i
                class="fa-solid fa-xmark"></i></button>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="rh-bottom">
      <div class="rh-groups">
        <div class="rh-group">
          <span class="rh-label"><i class="fa-solid fa-user me-1"></i>Katılımcılar</span>
          <div class="chips">
            @for (p of participants; track p.id) {
            <span class="human-chip">{{ p.name }}@if (p.isOwner) { <i class="fa-solid fa-crown owner-icon"
                title="Toplantı sahibi"></i> }</span>
            } @empty {
            <span class="text-muted small">—</span>
            }
          </div>
        </div>
        @if (approvedExperts.length) {
        <div class="rh-group">
          <span class="rh-label"><i class="fa-solid fa-robot me-1"></i>Uzmanlar (AI)</span>
          <div class="chips">
            @for (e of approvedExperts; track e.code) {
            <span class="role-chip" [class]="'role-chip ' + roleClass(e.code)" [title]="e.title || ''"><b>{{ e.code
                }}</b> · {{ e.name }}</span>
            }
          </div>
        </div>
        }
      </div>

      <!-- Sağda: davet butonu (katılımcıların sağında) -->
      <div class="rh-bottom-side">
        <button class="btn btn-sm btn-outline-primary" style="margin-top:15px;" (click)="copyInvite()">
          @if (inviteCopied) { <i class="fa-solid fa-check me-1"></i>Kopyalandı } @else { <i
            class="fa-solid fa-user-plus me-1"></i>Davet Et }
        </button>
      </div>
    </div>

    @if (inviteLink) {
    <div class="input-group input-group-sm mt-2" style="max-width: 420px;">
      <span class="input-group-text"><i class="fa-solid fa-link"></i></span>
      <input class="form-control" readonly [value]="inviteLink" (click)="$any($event.target).select()">
      <button class="btn btn-outline-secondary" (click)="inviteLink = ''"><i class="fa-solid fa-xmark"></i></button>
    </div>
    }
  </div>

  <!-- Rapor görünümü (tam genişlik) -->
  @if (showReport && reportHtml) {
  <div class="panel-card mb-3">
    <div class="d-flex justify-content-end gap-2 mb-3">
      <button class="btn btn-sm btn-outline-primary" (click)="downloadMarkdown()">
        <i class="fa-solid fa-download me-1"></i>Markdown (.md)
      </button>
      <button class="btn btn-sm btn-primary" (click)="downloadPdf()">
        <i class="fa-solid fa-file-pdf me-1"></i>PDF olarak indir
      </button>
    </div>
    <div class="report-markdown" #reportEl [innerHTML]="reportHtml"></div>
  </div>
  } @else {

  <!-- Sol: konuşma akışı — Sağ: kalıcı Toplantı Durumu kolonu -->
  <div class="room-body">
    <div class="room-main">
      <div class="panel-card feed-card">
        <div class="feed" #feed>
          <div class="message-wrapper">
            @for (m of messages; track m.id) {
            @if (m.role === 'system') {
            <div class="system-note"><i class="fa-solid fa-circle-info me-1"></i>{{ m.content }}</div>
            } @else {
            <div class="message-template" [class.left]="!isMine(m)">
              <div class="img-area">
                <div class="img" [class]="'img ' + avatarClass(m)">{{ initials(m) }}</div>
              </div>
              <div class="message-area">
                <div class="message"><span [innerHTML]="displayHtml(m)"></span>@if (m._animating) { <span
                    class="type-caret"></span> }</div>
                <div class="info">
                  <span class="fw-semibold">{{ speakerLabel(m) }}</span>
                  <span>{{ m.createdAt | date:'HH:mm' }}</span>
                </div>
              </div>
            </div>
            }
            }

            @if (generating || sending) {
            <div class="message-template left">
              <div class="img-area">
                <div class="img avatar-moderator">M</div>
              </div>
              <div class="message-area">
                <div class="message thinking"><span class="dot"></span><span class="dot"></span><span
                    class="dot"></span></div>
                @if (sending) { <div class="info"><span class="fw-semibold">Moderatör yönlendiriyor…</span></div> }
              </div>
            </div>
            }
            @if (finalizing) {
            <div class="system-note"><i class="fa-solid fa-spinner fa-spin me-1"></i>Decision Engine final raporu
              hazırlıyor...</div>
            }
          </div>
        </div>

        <!-- Katılımcı mesaj alanı -->
        @if (meeting.status !== 'Completed' && me) {
        <div class="ceo-input">
          @if (mentionOpen && filteredMentions.length) {
          <div class="mention-menu">
            @for (it of filteredMentions; track it.label) {
            <button type="button" class="mention-item" (mousedown)="$event.preventDefault(); pickMention(it)">
              <i [class]="it.icon + ' me-2'"></i>{{ it.label }}
            </button>
            }
          </div>
          }
          <textarea #userTa class="form-control" rows="2" [(ngModel)]="userText" [disabled]="sending"
            placeholder="{{ me.name }} olarak toplantıya katılın... @ ile uzman/katılımcı etiketleyebilirsiniz"
            (input)="onUserTextInput()" (keydown)="onUserTextKeydown($event)"
            (keydown.control.enter)="sendUserMessage()"></textarea>
          <button class="btn btn-primary" [disabled]="sending || !userText.trim()" (click)="sendUserMessage()"
            title="Gönder (Ctrl+Enter)">
            @if (sending) { <i class="fa-solid fa-spinner fa-spin"></i> } @else { <i
              class="fa-solid fa-paper-plane"></i> }
          </button>
        </div>
        }
      </div>
    </div>

    <!-- Sağ pano: yalnızca toplantı çıktıları (karar / risk / aksiyon / soru / özet) -->
    <aside class="room-status">
      <div class="status-body">
        @if (state) {
        <section class="sec sec-decisions">
          <h6><i class="fa-solid fa-circle-check me-2"></i>Kararlar</h6>
          <ul>@for (d of state.decisions || []; track $index) { <li [innerHTML]="annotateRoles(d)"></li> } @empty { <li
              class="empty">Henüz karar alınmadı</li> }</ul>
        </section>
        <section class="sec sec-risks">
          <h6><i class="fa-solid fa-triangle-exclamation me-2"></i>Riskler</h6>
          <ul>@for (r of state.risks || []; track $index) { <li [innerHTML]="annotateRoles(r)"></li> } @empty { <li
              class="empty">Öne çıkan risk yok</li> }</ul>
        </section>
        <section class="sec sec-actions">
          <h6><i class="fa-solid fa-list-check me-2"></i>Aksiyonlar</h6>
          <ul>@for (a of state.actions || []; track $index) { <li [innerHTML]="annotateRoles(a)"></li> } @empty { <li
              class="empty">Henüz aksiyon yok</li> }</ul>
        </section>
        <section class="sec sec-questions">
          <h6><i class="fa-regular fa-circle-question me-2"></i>Açık Sorular</h6>
          <ul>@for (q of state.openQuestions || []; track $index) { <li [innerHTML]="annotateRoles(q)"></li> } @empty {
            <li class="empty">Açık soru kalmadı</li> }</ul>
        </section>
        @if (state.summary) {
        <section class="sec sec-summary">
          <h6><i class="fa-solid fa-align-left me-2"></i>Özet</h6>
          <p class="summary" [innerHTML]="annotateRoles(state.summary)"></p>
        </section>
        }
        } @else {
        <div class="empty text-center py-4">
          <i class="fa-regular fa-clipboard fa-2x mb-2 d-block opacity-50"></i>
          Toplantı ilerledikçe kararlar, riskler ve aksiyonlar burada belirecek.
        </div>
        }
      </div>
    </aside>
  </div>
  }

</div>
<!-- /.room -->

<!-- Sağ altta akış durumu popup'ı -->
@if (meeting.status !== 'Completed' && meeting.status !== 'Setup' && !showReport) {
<div class="continue-popup">
  @if (suggestFinalize) {
  <div class="hint">Moderatör toplantıyı kapattı. Final raporu hazırlanabilir.</div>
  <button class="btn btn-primary btn-lg w-100" [disabled]="finalizing" (click)="finalize()">
    <i class="fa-solid fa-file-lines me-2"></i>Final Raporu Oluştur
  </button>
  } @else if (isOwner) {
  <button class="btn w-100" [class.btn-outline-primary]="!paused" [class.btn-primary]="paused" (click)="togglePause()">
    @if (paused) {
    <i class="fa-solid fa-play me-2"></i>Sürdür
    } @else {
    <i class="fa-solid fa-pause me-2"></i>Duraklat
    }
  </button>
  <div class="hint">
    @if (paused) {
    Toplantı duraklatıldı
    } @else {
    <span class="live-dot"></span> Toplantı akıyor — uzmanlar sırayla konuşuyor
    }
  </div>
  } @else {
  <div class="hint m-0"><span class="live-dot"></span> Canlı toplantıyı izliyorsunuz — mesaj yazarak katkı
    verebilirsiniz</div>
  }
</div>
}
}